export default {
  name: 'Radio',
  inject: {
    radioProvided: {
      default: null,
    },
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    leftLabel: Boolean,
    disable: Boolean,
    value: {
      default: '',
      type: [String, Object, Number, Array],
    },
    val: {
      default: '',
      type: [String, Object, Number, Array],
    },
    valuePropName: {
      type: String,
      default: '',
    },
  },
  computed: {
    isTrue() {
      const value = (this.radioProvided && this.radioProvided.value) || this.value;
      if (
        typeof value === 'object' &&
        typeof this.val === 'object' &&
        this.valuePropName
      ) {
        return value[this.valuePropName] === this.val[this.valuePropName];
      } else {
        return value === this.val;
      }
    },
    disabled() {
      return (this.radioProvided && this.radioProvided.disable) || this.disable;
    },
    classes() {
      return (this.disabled === true ? ' disabled' : '') +
        (this.isTrue === true ? ' checked' : '');
    },
    dynamicTabIndex() {
      return this.$props.disable ? '-1' : '0';
    },
  },
  methods: {
    toggle(e) {
      if (this.disabled !== true && this.isTrue !== true) {
        if (this.radioProvided) {
          this.radioProvided.emitInput(this.val);
          return;
        }
        this.$emit('input', this.val, e);
      }
    },
  },
};
